const Loaders = () => {
  return <div className="loaders"></div>;
};

export default Loaders;
